/* Tapis Home — retrait visuel prudent des marges blanches homogènes.
   Les fichiers et couleurs produits restent identiques. Fonctionne au défilement,
   sans traitement si la photo ou les droits d'accès pixels ne le permettent pas. */
(function () {
  'use strict';
  const selector = '.card__media img, .product__media img, .th-signo-gallery__photo, .image-with-text__media img, .multicolumn-card__image, .banner__media img, .thumbnail img';
  const seen = new WeakSet();
  const outcomes = new Map();
  const sampleSize = 112;
  const minEdge = 4;
  const maxEdge = 21;
  const minimumCrop = 14;
  const maxScale = 1.36;
  const pool = [];
  let active = 0;
  const maxActive = 2;
  function pureWhite(data, k) {
    const a = data[k+3], r = data[k], g = data[k+1], b = data[k+2];
    return a <= 5 || (a >= 249 && r >= 247 && g >= 247 && b >= 246 && Math.max(r,g,b) - Math.min(r,g,b) <= 8);
  }
  function analysePixels(img) {
    const cv = document.createElement('canvas');
    cv.width = cv.height = sampleSize;
    const ctx = cv.getContext('2d', {willReadFrequently:true});
    if (!ctx) return null;
    try { ctx.drawImage(img,0,0,sampleSize,sampleSize); } catch(e) {return null;}
    let pixels;
    try { pixels=ctx.getImageData(0,0,sampleSize,sampleSize).data; } catch(e) {return null;}
    const n=sampleSize;
    function blankRow(y) {
      let white=0, total=0;
      for(let x=4;x<n-4;x+=2) {total++;if(pureWhite(pixels,4*(y*n+x))) white++;}
      return white/total >= .97;
    }
    function blankCol(x) {
      let white=0,total=0;
      for(let y=4;y<n-4;y+=2) {total++;if(pureWhite(pixels,4*(y*n+x))) white++;}
      return white/total >= .97;
    }
    let top=0,bottom=0,left=0,right=0;
    while(top<maxEdge && blankRow(top))top++;
    while(bottom<maxEdge && blankRow(n-bottom-1))bottom++;
    while(left<maxEdge && blankCol(left))left++;
    while(right<maxEdge && blankCol(n-right-1))right++;
    // Seul un cadre complet, homogène et substantiel est corrigé.
    if(Math.min(top,bottom,left,right)<minEdge) return null;
    if(top+bottom+left+right<minimumCrop) return null;
    // Sécurité : ne pas recadrer une image presque entièrement blanche.
    let dark=0,count=0;
    for(let y=25;y<n-25;y+=4)for(let x=25;x<n-25;x+=4){
      count++;if(!pureWhite(pixels,4*(y*n+x))) dark++;
    }
    if(!count || dark/count < .2)return null;
    const horizontal=(left+right)/n,vertical=(top+bottom)/n;
    const scale=Math.max(1/(1-horizontal),1/(1-vertical));
    if(scale>maxScale)return null;
    const dx=(right-left)/n*scale*50,dy=(bottom-top)/n*scale*50;
    return {scale,dx,dy};
  }
  function process(target, url) {
    const cached=outcomes.get(url);
    if(cached!==undefined) {if(cached) apply(target,cached);return Promise.resolve();}
    return new Promise(resolve=>{
      const source=new Image();
      source.crossOrigin='anonymous';
      source.decoding='async';
      source.onload=function(){
        let crop=null;
        try {crop=analysePixels(source);}catch(e){}
        outcomes.set(url,crop);
        if(crop)apply(target,crop);
        resolve();
      };
      source.onerror=function(){outcomes.set(url,null);resolve();};
      source.src=url;
    });
  }
  function apply(img,crop){
    if(!img.isConnected)return;
    img.style.setProperty('--th-crop-scale',String(crop.scale.toFixed(3)));
    img.style.setProperty('--th-crop-x',crop.dx.toFixed(3)+'%');
    img.style.setProperty('--th-crop-y',crop.dy.toFixed(3)+'%');
    img.classList.add('th-white-margin-trimmed');
  }
  function pump(){
    while(active<maxActive && pool.length){
      const item=pool.shift();active++;
      process(item.img,item.url).finally(()=>{active--;pump();});
    }
  }
  function visit(img){
    if(seen.has(img))return;
    seen.add(img);
    function enqueue(){
      if(!img.isConnected)return;
      const url=img.currentSrc||img.src;
      if(!url||!/^https?:\/\//.test(url))return;
      pool.push({img,url});
      pump();
    }
    if(img.complete&&img.naturalWidth>0)enqueue();
    else img.addEventListener('load',enqueue,{once:true});
  }
  let io=null;
  if('IntersectionObserver'in window){
    io=new IntersectionObserver(entries=>{
      entries.forEach(e=>{if(!e.isIntersecting)return;io.unobserve(e.target);visit(e.target);});
    },{rootMargin:'300px'});
  }
  function scan(root){
    if(root.matches && root.matches(selector)){if(io)io.observe(root);else visit(root);}
    if(!root.querySelectorAll)return;
    root.querySelectorAll(selector).forEach(img=>{if(io)io.observe(img);else visit(img);});
  }
  function start(){
    scan(document);
    document.addEventListener('shopify:section:load',e=>scan(e.target));
    const container=document.querySelector('#MainContent');
    if(container&&'MutationObserver'in window){
      new MutationObserver(mutations=>mutations.forEach(m=>m.addedNodes.forEach(node=>{
        if(node.nodeType===1)scan(node);
      }))).observe(container,{childList:true,subtree:true});
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
})();
